export default __webpack_public_path__ + "static/media/airlockz-bpk-banner-2.71a82874.jpg";